(function ($) {

  window.setTimeout(function () {
    $('.keep-scrolling-trigger').on('click', function () {
      gtag('event', 'click', {
        'event_category': 'bouncing_icon'
      })
    })

    $('[data-download]').each(function (i, e) {
      $(e).on('click', function () {
        console.log(`${e.dataset.download.toLowerCase()}_casestudy`)
        gtag('event', 'download', {
          'event_category': `${e.dataset.download.toLowerCase()}_casestudy`
        })
      })
    })

    $('[data-service]').each(function (i, e) {
      $(e).on('click', function () {
        gtag('event', 'click', {
          'event_category': `${e.dataset.service}_service`
        })
      })
    })

    $('.contact-form').on('submit', function () {
      gtag('event', 'submit', {
        'event_category': 'contactus_submit'
      })
    })

  }, 2000)

})(jQuery)



// WEBPACK FOOTER //
// ./src/assets/js/_analytics_events.js